import { AlertTriangle } from 'lucide-react';
import { useTheme } from './ThemeContext';

export default function StockWarningBadge({ size = 'small', showText = false }) {
  const { colors } = useTheme();

  const isSmall = size === 'small';

  return (
    <span style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '0.25rem',
      padding: isSmall ? '0.15rem 0.4rem' : '0.25rem 0.5rem',
      background: `${colors.warning}20`,
      border: `1px solid ${colors.warning}50`,
      borderRadius: '4px',
      color: colors.warning,
      fontSize: isSmall ? '0.7rem' : '0.8rem',
      fontWeight: 'bold'
    }}>
      <AlertTriangle size={isSmall ? 12 : 14} />
      {showText && 'Low Stock'}
    </span>
  );
}
